import { useAction, useAtom } from "@reatom/npm-react";
import { useCallback } from "react";

import { searchProductStore } from "../store/fetchers";

export const useInfinityScroll = () => {
  const [isFetchLoading] = useAtom(searchProductStore.isFetchLoading);
  const [isLoading] = useAtom(searchProductStore.isLoading);
  const [isRefreshing] = useAtom(searchProductStore.isRefreshing);
  const [hasNext] = useAtom(searchProductStore.hasNext);

  const [products] = useAtom(searchProductStore.productsAtom);
  const addProducts = useAction(searchProductStore.addProducts);

  const onLoadMore = useCallback(async () => {
    if (isFetchLoading || isLoading || !hasNext) return;
    await addProducts();
  }, [addProducts, isFetchLoading, isLoading, hasNext]);

  return {
    products,
    isFetchLoading,
    isLoading,
    isRefreshing,
    hasNext,
    onLoadMore,
  };
};
